import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function InfoCircleStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M12.0088 7L12.1113 7.00488C12.6156 7.05612 13.0088 7.48225 13.0088 8C13.0088 8.51775 12.6156 8.94388 12.1113 8.99512L12.0088 9H12C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7H12.0088Z"
				fill="currentColor"
			/>
			<path
				d="M11.75 16.5V12.0996C11.75 11.9676 11.7501 11.8637 11.748 11.7744C11.7479 11.7663 11.7463 11.7585 11.7461 11.751C11.6778 11.7498 11.5986 11.75 11.5 11.75C11.0858 11.75 10.75 11.4142 10.75 11C10.75 10.5858 11.0858 10.25 11.5 10.25C11.7124 10.25 11.9545 10.2482 12.1582 10.2783C12.3623 10.3085 12.6062 10.3801 12.8193 10.5684L12.9082 10.6562L12.9854 10.75C13.1477 10.9712 13.203 11.2122 13.2266 11.4053C13.2517 11.611 13.25 11.8598 13.25 12.0996V16.5C13.25 16.9142 12.9142 17.25 12.5 17.25C12.0858 17.25 11.75 16.9142 11.75 16.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

InfoCircleStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default InfoCircleStrokeIcon;
